const topNav = [
    { id: 1, label: "Home", href: "home" },
    // { id: 2, label: "Update Plan", href: "update-plan" },
    { id: 3, label: "Privacy Policy", href: "privacy-policy" }
  ];
  
  export const getTopNav = () => {
    return topNav;
  };